import DashboardView from './DashboardView';
import { MeasureListContextProvider } from '../../contexts/MeasureListContext';
import { Box } from '@mui/material';

export default function DashboardLayout(props) {
    return (
        <Box
            sx={{
                display: 'flex',
                minHeight: '100%',
                overflow: 'hidden'
            }}
        >
            <Box
                sx={{
                    flexGrow: 1,
                    overflow: 'auto',
                    minHeight: '100%',
                }}
            >
                <MeasureListContextProvider>
                    <DashboardView />
                </MeasureListContextProvider>
            </Box>
        </Box >
    );
}
